<template>
	<form>
		<div class="vx-row">
			<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
				<vs-input label="Voorraad" type="number" v-validate="'integer'" name="stock"
						  v-model="product.stock"></vs-input>
				<span class="text-danger text-sm"
					  v-show="errors.has('stock')">{{
					errors.first('stock')
				}}</span>
			</div>
			<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
				<vs-input label="Bundel aantal" type="number" v-validate="'integer'" name="bundle_quantity"
						  v-model="product.bundle_quantity"></vs-input>
				<span class="text-danger text-sm"
					  v-show="errors.has('bundle_quantity')">{{
					errors.first('bundle_quantity')
				}}</span>
			</div>
			<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
				<vs-input label="Prijs" type="number" name="price" v-model="product.price" disabled></vs-input>
			</div>
			<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
				<vs-input label="Lage voorraad melding" type="number" v-validate="'integer'"
						  name="stock_threshold"
						  v-model="product.stock_threshold"></vs-input>
				<span class="text-danger text-sm"
					  v-show="errors.has('stock_threshold')">{{
					errors.first('stock_threshold')
				}}</span>
			</div>
			<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
				<vs-input label="Locatie" name="location" v-model="product.location"></vs-input>
			</div>
			<div class="vx-col w-full">
				<vs-input label="Inkoop url" v-validate="'url'" name="buy_url"
						  v-model="product.buy_url"></vs-input>
				<span class="text-danger text-sm"
					  v-show="errors.has('buy_url')">{{
					errors.first('buy_url')
				}}</span>
			</div>
		</div>

		<!-- Prijzen Section -->
		<div class="prices-section">
			<h3 class="section-title">💰 Prijzen</h3>
			<div class="vx-row">
				<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
					<vs-input label="Inkoopprijs (excl. btw)" type="number" name="purchase_price"
							  v-model="product.purchase_price"></vs-input>
				</div>
				<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
					<vs-input label="Verzendkosten (excl. btw)" type="number" name="shipment_price"
							  v-model="product.shipment_price"></vs-input>
				</div>
				<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
					<vs-input label="Vaste commissie (excl. btw)" type="number" name="fixed_commission"
							  v-model="product.fixed_commission"></vs-input>
				</div>
				<div class="vx-col lg:w-1/2 md:w-1/2 w-full">
					<vs-input label="Variabele commissie (excl. btw)" type="number" name="variable_commission"
							  v-model="product.variable_commission"></vs-input>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';
import {mapActions} from 'vuex';

Vue.use(VeeValidate);
const dict = {
	custom: {
		stock: {
			integer: 'De voorraad kan alleen uit cijfers bestaan',
		},
		stock_threshold: {
			integer: 'Voer hier de minimale product voorraad in',
		},
		buy_url: {
			url: 'Dit is geen geldige link',
		},
	}
};
Validator.localize('en', dict);
export default {
	name: 'product',
	props: {
		product: {},
	},
	methods: {
		...mapActions({
			getProducts: 'productStore/getProducts',
			updateProduct: 'productStore/updateProducts',
		}),
		validate() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.update()
				} else {
					this.$vs.notify({
						title: 'Error',
						text: 'Controleer de gegevens en probeer opnieuw',
						color: 'danger'
					});
				}
			})
		},
		update() {
			const params = {
				product_id: this.product.id,
				location: this.product.location,
				stock: this.product.stock,
				bundle_quantity: this.product.bundle_quantity,
				purchase_price: this.product.purchase_price,
				stock_threshold: this.product.stock_threshold,
				buy_url: this.product.buy_url,
				price: this.product.price,
				shipment_price: this.product.shipment_price,
				fixed_commission: this.product.fixed_commission,
				variable_commission: this.product.variable_commission,
			};
			if (params.stock === '') {
				params.stock = 0
			}
			this.updateProduct(params).then(result => {
				this.getProducts();
				this.$vs.notify({
					title: 'Gelukt',
					text: 'Je wijzigingen zijn opgeslagen',
					color: 'success'
				});
			}).catch(error => {
				console.log(error);
				this.$vs.notify({
					title: 'Error',
					text: 'Er is iets mis gegaan, probeer het opnieuw',
					color: 'danger'
				});
			});
		}
	}
}
</script>

<style scoped>
.prices-section {
	margin-top: 32px;
	padding-top: 32px;
	border-top: 2px solid #f0f0f0;
}

.section-title {
	font-size: 16px;
	font-weight: 600;
	color: #333;
	margin: 0 0 20px 0;
	display: flex;
	align-items: center;
	gap: 8px;
}

body.theme-dark .section-title {
	color: #e0e0e0;
	border-bottom-color: #3a3a3a;
}

body.theme-semi-dark .section-title {
	color: #e0e0e0;
	border-bottom-color: #404040;
}

body.theme-dark .prices-section {
	border-top-color: #3a3a3a;
}

body.theme-semi-dark .prices-section {
	border-top-color: #404040;
}
</style>

